import { initializeFormValidation } from './utils/formValidation';
import { initializePasswordToggle } from './utils/passwordToggle';
import { initializeRecaptchaFormGate } from './utils/recaptchaFormGate';

function initializeLoginEntry(): void {
  initializePasswordToggle();
  initializeRecaptchaFormGate();
  initializeFormValidation();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeLoginEntry);
} else {
  initializeLoginEntry();
}
